import { FastApiAxiosInstance } from 'common/service/axiosInstances';

export interface SystemVersion {
  version: string;
  downloadUrl: string;
  force: boolean;
  platform: 'ANDROID' | 'IOS';
}

const system = {
  getSystemVersion: async () => {
    return FastApiAxiosInstance.get<SystemVersion[]>('/api/v1/system/versions');
  },
};

export default system;
